﻿import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";
import { animate, inView } from "motion";

const rotateInFromRight = {
  transform: ["translateX(100%) rotate(15deg)", "translateX(0) rotate(0deg)"],
  opacity: [0, 1]
};

const rotateInFromLeft = {
  transform: ["translateX(-100%) rotate(-15deg)", "translateX(0) rotate(0deg)"],
  opacity: [0, 1]
};

const animationOptions = {
  duration: 0.8,
  easing: "ease-out"
};

function removeAnimationStyles(element: HTMLElement, stop: VoidFunction) {
  setTimeout(() => {
    element.style.removeProperty("transform");
    element.style.removeProperty("opacity");
    stop();
  }, 0);
}

export const animateCampaign = (blocks: NodeListOf<HTMLElement>) => {
  // Animate when scrolled into view
  if (!prefersReducedMotion()) {
    blocks.forEach(block => {
      const content = block.querySelector<HTMLElement>(
        ".rotate-in-from-right"
      );
      const picture = block.querySelector<HTMLElement>(".rotate-in-from-left");

      if (content) {
        const stopContent = inView(content, (entry: IntersectionObserverEntry) => {
          animate(entry.target, rotateInFromRight, {
            ...animationOptions,
            onComplete: () => removeAnimationStyles(entry.target as HTMLElement, stopContent)
          })
        })
      }

      if (picture) {
        const stopPicture = inView(picture, (entry: IntersectionObserverEntry) => {
          animate(entry.target, rotateInFromLeft, {
            ...animationOptions,
            onComplete: () => removeAnimationStyles(entry.target as HTMLElement, stopPicture)
          })
        })
      }
    });
  }
}